module.exports = __webpack_public_path__ + "static/media/fotogalereya12.99c3af07.jpg";